/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getComponentZoneLayout } from "cms/components/components/component";
import { SectionLinkCardsComponentDisplay } from "cms/components/components/section-link-cards/display";
import { SectionLinkCardsComponentEditor } from "cms/components/components/section-link-cards/edit";

const SectionLinkCardsComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <SectionLinkCardsComponentDisplay />,
        editComponent: <SectionLinkCardsComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

SectionLinkCardsComponent.displayName = "SectionLinkCardsComponent";
export { SectionLinkCardsComponent };
